import { render, staticRenderFns } from "./ParticipantTeamList.vue?vue&type=template&id=6973c7b5&"
import script from "./ParticipantTeamList.vue?vue&type=script&lang=js&"
export * from "./ParticipantTeamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports